module.exports = __webpack_public_path__ + "static/media/astar_step_3.e9d5a5de.png";